import React from 'react'
import "./styles.scss"

export default function Para(props) {
  const {children, ...rest}=props;
  const className = props.className || '';
  return (
    <p className={`${className}`} {...rest}>
      {children}
    </p>
  )
}
